module.exports = __webpack_public_path__ + "static/4-aaec9e89425597b98eee3fd3e5f04bbc.jpg";